<template>
  <transition name="fade">
    <div class="dialog-back" v-show="show">
      <div class="dialog">
        <strong class="dialog-title">{{title}}</strong>
        <vnodes :vnodes="text" v-if="typeof text === 'object'"/>
        <div class="dialog-text" v-else-if="text">{{text}}</div>
        <div class="dialog-btn">
          <div class="cancel-btn" v-if="cancelText" @click="cancel">{{cancelText}}</div>
          <div class="confirm-btn" @click="callback">{{confirmText}}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "wx-dialog",
    components: {
        Vnodes: {
            functional: true,
            render: (h, ctx) => ctx.props.vnodes
        }
    },
    data () {
      return {
        title: '提示',
        text: null,
        cancelText: '取消',
        confirmText: '确认',
        fn: null,
        onCancel: null,
        hold: false,
        show: true
      }
    },
    methods: {
      cancel() {
        this.show = false;
        typeof this.onCancel === 'function' && this.onCancel();
      },
      callback() {
        !this.hold && (this.show = false);
        typeof this.fn === 'function' && this.fn();
      }
    }
  };
</script>

<style lang="less">
  .dialog-back {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 99;
    .dialog {
      position: fixed;
      width: 80%;
      max-width: 600px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -80%);
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      text-align: center;
      .dialog-title {
        display: block;
        padding: 1em 1.6em;
        font-size: 32px;
        font-weight: 400;
      }
      .dialog-text {
        padding: 0 3em 0.8em;
        min-height: 80px;
        font-size: 30px;
        line-height: 1.8;
        word-wrap: break-word;
        word-break: break-all;
        color: #999;
      }
      .dialog-btn {
        display: flex;
        align-items: center;
        border-top: 1px solid rgba(151, 151, 151, .2);
      }
      .cancel-btn,
      .confirm-btn {
        flex: 1;
        font-size: 32px;
        line-height: 96px;
      }
      .cancel-btn {
        border-right: 1px solid rgba(151, 151, 151, .2);
      }
      .confirm-btn {
        color: #ff6e02;
      }
    }
  }
</style>
